import React from "react";
import {
	formatLayawayMoney,
	layawayOverpaymentCredit,
	layawayRefundDue,
	layawayTotalRefundDueAfterChange,
} from "../../utils/layawayRefundDue";

/**
 * Explains incremental vs cumulative customer credit when a layaway contract change would overpay.
 */
export default function LayawayOverpaymentNotice({
	contractAmount,
	contractRemaining,
	previewContractAmount,
	actionLabel = "This change",
}) {
	const incremental = layawayOverpaymentCredit(previewContractAmount, contractAmount, contractRemaining);
	const existingCredit = layawayRefundDue(contractRemaining);
	const totalAfter = layawayTotalRefundDueAfterChange(
		previewContractAmount,
		contractAmount,
		contractRemaining
	);

	return (
		<>
			{existingCredit > 0.005 ? (
				<>
					{actionLabel} adds <strong>${formatLayawayMoney(incremental)}</strong> to the existing{" "}
					<strong>${formatLayawayMoney(existingCredit)}</strong> credit on this layaway.
					<br/>
					<strong>Total refund due after this change: ${formatLayawayMoney(totalAfter)}.</strong>
				</>
			) : (
				<>
					{actionLabel} leaves the customer paid <strong>${formatLayawayMoney(incremental)}</strong> more
					than the new contract total.
					<br/>
					<strong>Refund due after this change: ${formatLayawayMoney(totalAfter)}.</strong>
				</>
			)}
			<br/><br/>
			The layaway stays <strong>open</strong> with that credit on the balance — no money is returned automatically.
			After you save, use the <strong>Refund</strong> button on this layaway to pay the customer back. If a single
			payment is larger than the amount owed, enter a <strong>restocking fee</strong> so cash back matches the
			refund due — the fee stays with the store and does not credit the layaway balance.
		</>
	);
}
